// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"audiencePictureMessage_mainContainer__3uXUA","userImg":"audiencePictureMessage_userImg__2P_t8","messageContainer":"audiencePictureMessage_messageContainer__p9zgu"};